import React, { useState, useEffect } from "react";

import NotificationsPanel from "@/partials/settings/NotificationsPanel";
import AppNotificationPanel from "@/partials/settings/AppNotificationPanel";
import { useSelector } from "react-redux";
import CanView from "@/components/CanView.jsx";
import SoundSelector from "@/components/SoundSelector.jsx";


function Notifications() {
  const { selectedLocation } = useSelector((state) => state.app);
  const [selectedSound, setSelectedSound] = useState("Classic.aiff");

  // Load sound preference from localStorage on mount
  useEffect(() => {
    const savedSound = localStorage.getItem('notification_sound');
    if (savedSound) {
      // Convert MP3 back to AIFF for the dropdown (since dropdown uses AIFF filenames)
      const aiffFilename = savedSound.replace('.mp3', '.aiff');
      setSelectedSound(aiffFilename);
    }
  }, []);

  // Handle sound selection change
  const handleSoundChange = (filename) => {
    setSelectedSound(filename);
    // Store MP3 version for web playback
    const mp3Filename = filename.replace('.aiff', '.mp3').toLowerCase().replace(" ", "");
    localStorage.setItem('notification_sound', mp3Filename);
  };

  if (!selectedLocation) return null;

  return (
    <main className="grow">
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        {/* Page header */}
          <div className="mb-8">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
              Notification Settings{" "}
              {selectedLocation?.name ? `for ${selectedLocation.name}` : ""}
            </h1>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8">
            <div className="flex flex-col md:flex-row md:-mr-px">
              <NotificationsPanel />
            </div>
          </div>

        <CanView appOnly>
          <div className="mb-8">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
              App notifications for this device
            </h1>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8">
            <div className="flex flex-col md:flex-row md:-mr-px">
              <AppNotificationPanel />
            </div>
          </div>
        </CanView>

        <CanView webOnly>
          <div className="mb-8">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
              Web Notification Sound
            </h1>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8">
            <div className="p-6">
              <h2 className="text-xl text-slate-800 dark:text-slate-100 font-bold mb-4">
                Choose Notification Sound
              </h2>
              
              <div className="text-sm text-slate-600 dark:text-slate-400 mb-6">
                Select a notification tone for web notifications. The sound will play when you receive notifications in your browser.
              </div>

              {/* Notification Sound Selection */}
              <SoundSelector
                selectedSound={selectedSound}
                onSoundChange={handleSoundChange}
                defaultSound="Classic.aiff"
                description="Select a notification tone to hear how it sounds. Your preference is automatically saved."
              />
            </div>
          </div>
        </CanView>
      </div>
    </main>
  );
}

export default Notifications;
